import axios, {AxiosResponse} from 'axios';
import {
    EMPLOYMENT_BATCH_ENDPOINT, EMPLOYMENT_ENDPOINT, EMPLOYMENT_GRANTS_ENDPOINT
} from '@/constants/endpoints'
import authHeader from "@/services/auth-header";
import QueryUtils from "@/utils/QueryUtils";
import EmploymentDTO from "@/dto/employee/EmploymentDTO";
import CreateEmploymentRequestDTO from "@/dto/employee/CreateEmployeeRequestDTO";
import Workspaces from "@/state/Workspaces";
import { IEmployment } from "@/dto/payroll/IEmployment";
import {EmploymentFilter} from "@/dto/payroll/Filters";
import Pageable from "@/dto/Pageable";
import GrantDTO from "@/dto/auth/GrantDTO";
import { ChargeComponent } from "@/dto/subscription/SublimeChargeDTO";
class EmploymentService {

    batchUpload(fileId: number){
        return axios.post(`${EMPLOYMENT_BATCH_ENDPOINT}/${fileId}`,{},{headers: authHeader()});
    }

    createEmployment(employee: CreateEmploymentRequestDTO){
        return axios.post<EmploymentDTO>(EMPLOYMENT_ENDPOINT, employee, {headers: authHeader()});
    }

    getPageByFilter<T extends IEmployment>(filter: EmploymentFilter): Promise<AxiosResponse<Pageable<T>>> {
        const queryString = QueryUtils.objectToQueryString(filter)
        return axios.get<Pageable<T>>(`${EMPLOYMENT_ENDPOINT}/page${queryString}`, {headers: authHeader()});
    }

    getAllByFilter<T extends IEmployment>(filter: EmploymentFilter): Promise<AxiosResponse<Array<T>>> {
        const queryString = QueryUtils.objectToQueryString(filter)
        return axios.get<Array<T>>(`${EMPLOYMENT_ENDPOINT}${queryString}`, {headers: authHeader()})
    }

    public getById<T extends IEmployment | null>(employmentId: number | string) {
        return axios.get<T>(`${EMPLOYMENT_ENDPOINT}/${employmentId}`, {headers: authHeader()});
    }

    getAllEmploymentsByDetailsId(detailsId: number = Workspaces.getCurrent.id) {
        return axios.get<Array<IEmployment>>(`${EMPLOYMENT_ENDPOINT}/details/${detailsId}`, {headers: authHeader()})
    }

    getGrants(employmentId: number, component: ChargeComponent): Promise<AxiosResponse<Array<GrantDTO>>> {
        const params: Record<string, any> = { employmentId, component };
        const query = new URLSearchParams();
        Object.entries(params).forEach(([k, v]) => {
            if (v !== undefined && v !== null && v !== '') query.append(k, String(v));
        });
        return axios.get<Array<GrantDTO>>(`${EMPLOYMENT_GRANTS_ENDPOINT}?${query.toString()}`, { headers: authHeader() });
    }

    createGrant(employmentId: number, component: ChargeComponent, action: string, scopeProjectId: number | null = null, scopeEmploymentId: number | null = null): Promise<AxiosResponse<GrantDTO>> {
        const payload = {
            employmentId,
            component,
            action,
            scopeProjectId,
            scopeEmploymentId: scopeEmploymentId || employmentId
        };
        return axios.post<GrantDTO>(EMPLOYMENT_GRANTS_ENDPOINT, payload, { headers: authHeader() });
    }

}

export default new EmploymentService();
